import { inject, Pipe, PipeTransform } from '@angular/core';
import { CustomFieldType, CustomFieldUtility, DateUtility, Entity } from '@jms/model';
import { GeneralSettingService } from '@jms/ui/ui.standalone.services/general.setting.service';
import { CustomFieldTypePipe } from './custom.field.type.pipe';

@Pipe({
    name: 'customFieldValue',
    standalone: false
})
export class CustomFieldValuePipe implements PipeTransform {

    private readonly generalSettings = inject(GeneralSettingService);
    private readonly types: Entity[];

    constructor(
        private typePipe: CustomFieldTypePipe
    ) { }

    transform(value: any, fieldId: any): any {
        const type = this.typePipe.transform(fieldId) as CustomFieldType;

        // Render Date/DateTime per Regional Settings (was hardcoded dd/MM/yy [hh:mm a]).
        // Keep the existing zone so times don't shift — format bug, not a timezone conversion.
        if (type === CustomFieldType.Date || type === CustomFieldType.DateTime) {
            if (!value) return 'Not Set';

            const region = this.generalSettings.generalSettings?.region;
            const dateFormat = region?.dateFormat ?? 'dd/MM/yy';
            const timeFormat = region?.timeFormat ?? 'hh:mm a';

            const isDateTime = type === CustomFieldType.DateTime;
            const zone = isDateTime ? DateUtility.getZoneFormIsoString(value?.toString()) : 'utc';
            const format = isDateTime ? `${dateFormat} ${timeFormat}` : dateFormat;

            return DateUtility.formatDateTime(value, zone, format);
        }

        return CustomFieldUtility.getFieldValue(type, value);
    }
}
